import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstagramIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 35,
	viewBox: "0 0 35 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 17.5,
			cy: 17.5,
			r: 17,
			stroke: "#003B6F"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_15507_527)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M21.2448 9.33398H13.754C11.3161 9.33398 9.33276 11.3173 9.33276 13.7553V21.2461C9.33276 23.6839 11.3161 25.6673 13.754 25.6673H21.2449C23.6827 25.6673 25.6661 23.6839 25.6661 21.2461V13.7553C25.6661 11.3173 23.6827 9.33398 21.2448 9.33398V9.33398ZM17.4994 21.9666C15.0368 21.9666 13.0334 19.9632 13.0334 17.5006C13.0334 15.038 15.0368 13.0346 17.4994 13.0346C19.962 13.0346 21.9654 15.038 21.9654 17.5006C21.9654 19.9632 19.962 21.9666 17.4994 21.9666ZM22.0722 14.0879C21.3445 14.0879 20.7526 13.4959 20.7526 12.7682C20.7526 12.0405 21.3445 11.4484 22.0722 11.4484C22.8 11.4484 23.392 12.0405 23.392 12.7682C23.392 13.4959 22.8 14.0879 22.0722 14.0879Z",
					fill: "#003B6F"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.4993 13.9922C15.5648 13.9922 13.9908 15.5661 13.9908 17.5007C13.9908 19.4352 15.5648 21.0092 17.4993 21.0092C19.434 21.0092 21.0078 19.4352 21.0078 17.5007C21.0078 15.5661 19.434 13.9922 17.4993 13.9922Z",
					fill: "#003B6F"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.072 12.4062C21.8723 12.4062 21.7098 12.5687 21.7098 12.7684C21.7098 12.968 21.8723 13.1305 22.072 13.1305C22.2717 13.1305 22.4342 12.9681 22.4342 12.7684C22.4342 12.5686 22.2717 12.4062 22.072 12.4062Z",
					fill: "#003B6F"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_15507_527",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16.3333,
				height: 16.3333,
				fill: "white",
				transform: "translate(9.33276 9.33398)"
			})
		}) })
	]
});
export default SvgInstagramIcon;
